export default __webpack_public_path__ + "static/basics_halbmond-472c6448fdd8c13b6588fe2f0892a0a0.jpg";